import { fetchApi } from './api'
import type { EntityMetric } from '../types/api'

/**
 * `GET /api/metrics/entities?top=&days=` — entities ranked by records processed.
 *
 * THE ONE WRAPPER for this endpoint. services/api.ts `getEntityMetrics(top)` sent no `days`, so the
 * server defaulted it while a caller's label could claim any window; the fixture `getTopEntities`
 * in services/observatoryApi.ts never called the API at all. Both are deleted with the fixture
 * layer.
 *
 * What it counts (MetricsController.GetEntityMetrics): `Etl.EtlActivityLog` rows of type
 * `EtlCompleted` inside the window, grouped by entity, summed `RecordsProcessed`. Only SUCCESSFUL
 * loads, then — a failed run contributes nothing — so a label must say "successful loads". The
 * server clamps `top` to 1..50 and `days` to its own range; both are sent so the heading and the
 * request cannot disagree.
 */
export function getTopEntities(top: number, days: number): Promise<EntityMetric[]> {
  const params = new URLSearchParams({ top: String(top), days: String(days) })
  return fetchApi<EntityMetric[]>(`/api/metrics/entities?${params.toString()}`)
}
